import {isNil, isNotNil} from 'ramda';

import {getSafely, parseDate} from 'shared/web';

type PriceChange = {price: number; date: number};

export type VehiclePriceChangeSource = {
  price_changes?: number[] | null;
  price_changes_dates?: string[] | null;
  original_currency?: string | null;
  original_price_with_vat?: number | null;
  price_with_vat?: number | null;
};

export function getPriceChanges(vehicle?: VehiclePriceChangeSource | null) {
  return (
    vehicle?.price_changes
      ?.map((price, index) => {
        const date = parseDate(getSafely(vehicle.price_changes_dates, index))?.getTime();

        return isNil(date) ? undefined : {price, date};
      })
      .filter((priceChange): priceChange is PriceChange => isNotNil(priceChange))
      .sort((a, b) => a.date - b.date) ?? []
  );
}
